import {
  Col,
  Divider,
  Input,
  Row,
  Space,
  Spin,
  Table,
  Tag,
  Typography,
  Modal,
  Rate,
  Badge,
} from 'antd';
import Link from 'antd/lib/typography/Link';
import React, { FC, useEffect, useMemo, useRef, useState } from 'react';
import { useQueryParam } from 'use-query-params';
import { FlexBox } from '../../../../components/atoms/FlexBox';
import { CycleToggle } from '../../../../components/atoms/ItemToggle';
import { UserAvatar } from '../../../../components/atoms/UserAvatar';
import ReviewPreview from '../../../../components/molecules/ReviewPreview/ReviewPreview';
import { useConnection } from '../../../../connection/Application';
import { PerformanceCycle } from '../../../../entity/PerformanceCycle';
import { WebUxPage, WebUxPageContent, WebUxPageItem } from '../../webux-layouts/WebUxPage';
import {
  AlignLeftOutlined,
  ArrowRightOutlined,
  CaretDownOutlined,
  CaretUpOutlined,
  RetweetOutlined,
  StarFilled,
} from '@ant-design/icons';
import { PeerReviewModel } from '../peer-reviews/PeerReviews';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';
import ReactHtmlParser from '../../../../utils/SafeHtmlParser';
import { PageHeader } from '@ant-design/pro-layout';
const { Title, Text } = Typography;
const { TextArea } = Input;

const regex = /(<([^>]+)>)/gi;

const UserPeerReviews: FC = () => {
  const [cycle, setCycle] = useQueryParam<number | undefined>('cycle');
  const cycleRef = useRef(cycle);
  const [cycles, setCycles] = useState<PerformanceCycle[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [tableData, setTableData] = useState<any>([]);
  const [record, setRecord] = useState<undefined | any>(undefined);
  const [showContent, setShowContent] = useState<boolean>(true);
  const connection = useConnection();
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [submitData, setSubmitData] = useState<PeerReviewModel>({
    criteriaSet: [],
    overallComment: '',
    submitTime: '',
    cycle: cycle,
    submittingUser: 0,
  });
  const params = useParams<{ id: string; name: string }>();
  const history1 = useHistory();

  const columns = useMemo(() => {
    return [
      {
        title: 'Peer Name',
        dataIndex: 'peerName',
        key: 'peerName',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => (
          <Space>
            <UserAvatar type={'user'} src={record.peerImage} />
            <Link
              onClick={() => {
                setSubmitData({
                  ...submitData,
                  criteriaSet: record?.criteriaSet?.criterias,
                  overallComment: record?.overallComment,
                });
                setModalVisible(true);
                setRecord(record);
              }}>
              {text}
            </Link>
          </Space>
        ),
      },
      {
        title: 'Reviewer',
        dataIndex: 'reviewerName',
        key: 'reviewerName',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => (
          <Space>
            <UserAvatar type={'user'} src={record.reviewerImage} />
            <Typography>{text}</Typography>
          </Space>
        ),
      },
      {
        title: 'Team',
        dataIndex: 'teamName',
        key: 'teamName',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => (
          <Space>
            <UserAvatar type={'team'} src={record.teamImage} />
            <Typography>{text}</Typography>
          </Space>
        ),
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => (
          <Space>
            {(record.status == '' || record.status == 'not submitted') && (
              <Tag color={'blue'}>Not submitted</Tag>
            )}
            {record.status == 'submitted' && <Tag color={'yellow'}>Submitted</Tag>}
            {record.status == 'approved' && <Tag color={'green'}>Approved</Tag>}
          </Space>
        ),
      },
      {
        title: 'Score',
        dataIndex: 'marks',
        key: 'marks',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => (
          <Space>
            {!(record.status == '' || record.status == 'not submitted') && (
              <Badge
                count={
                  record.criteriaSet.criterias.reduce(
                    (x: any, y: any) => x + (y.answer / y.type) * 100,
                    0,
                  ) /
                    record.criteriaSet.criterias.length +
                  '%'
                }
                showZero
                overflowCount={120}
                style={{ fontSize: '16px' }}
                color={
                  record.criteriaSet.criterias.reduce(
                    (x: any, y: any) => x + (y.answer / y.type) * 100,
                    0,
                  ) /
                    record.criteriaSet.criterias.length >
                  85
                    ? '#52c41a'
                    : record.criteriaSet.criterias.reduce(
                        (x: any, y: any) => x + (y.answer / y.type) * 100,
                        0,
                      ) /
                        record.criteriaSet.criterias.length >
                      60
                    ? '#faad14'
                    : ''
                }
              />
              // <Progress
              //   type="circle"
              //   percent={
              //     record.criteriaSet.criterias.reduce(
              //       (x: any, y: any) => x + (y.answer / y.type) * 100,
              //       0,
              //     ) / record.criteriaSet.criterias.length
              //   }
              //   width={65}
              //   format={() =>
              //     `${
              //       record.criteriaSet.criterias.reduce(
              //         (x: any, y: any) => x + (y.answer / y.type) * 100,
              //         0,
              //       ) / record.criteriaSet.criterias.length
              //     }%`
              //   }
              // />
            )}
          </Space>
        ),
      },
    ];
  }, [submitData]);

  useEffect(() => {
    const token = connection.hasSession();
    if (token) {
      setLoading(true);
      connection
        .get<{ performanceCycle: PerformanceCycle[]; closestCycle: PerformanceCycle }>('cycles')
        .then((value) => {
          setCycles(value.performanceCycle);
          if (cycleRef.current === undefined) {
            setCycle(value.closestCycle.id, 'replace');
          }
        })
        .catch(() => setLoading(false));
    }
  }, [connection, setCycle]);

  useEffect(() => {
    setLoading(true);
    if (cycle) {
      connection
        .get(`goals/review/user/${params.id}/${cycle}`)
        .then((users: any) => {
          setTableData(users.reviewForUser);
          setLoading(false);
        })
        .finally(() => setLoading(false));
    }
  }, [connection, cycle, params.id]);

  return (
    <WebUxPage>
      <PageHeader
        ghost={false}
        style={{ background: '#FFF' }}
        title={`${decodeURIComponent(params?.name ?? '')} Peer Reviews`}
        subTitle="View peer reviews"
        onBack={() => history1.goBack()}
        breadcrumb={{
          items: [
            {
              path: '',
              title: `Peer Review / ${decodeURIComponent(params?.name ?? '')}`,
            },
          ],
        }}
      />
      <WebUxPageContent>
        <WebUxPageItem>
          <FlexBox>
            <CycleToggle
              value={parseInt(`${cycle}`)}
              onChange={(value) => setCycle(value, 'replace')}
              data={cycles}
            />
          </FlexBox>
          <Spin spinning={loading}>
            <Table
              size="small"
              columns={columns}
              dataSource={tableData}
              expandable={{ indentSize: 0 }}
              pagination={false}
            />
          </Spin>
        </WebUxPageItem>
      </WebUxPageContent>
      <Modal
        destroyOnClose={true}
        open={modalVisible}
        okButtonProps={{ hidden: true }}
        onCancel={() => {
          setRecord(undefined);
          setSubmitData({
            criteriaSet: [],
            overallComment: '',
            submitTime: '',
            cycle: cycle,
            submittingUser: 0,
          });
          setModalVisible(false);
          // events.emit('PEER_REVIEW_CLOSE');
        }}>
        <Row style={{ marginTop: '3%' }}>
          <UserAvatar src={record?.peerImage ?? null} size={80} />
          <Col style={{ marginLeft: '3%' }}>
            <Title level={3} style={{ margin: 0 }}>
              {record?.peerName}
            </Title>
            <Text type="secondary">{record?.peerDesignation}</Text>
            <div>
              <Tag color="blue">{record?.teamName}</Tag>
            </div>
          </Col>
        </Row>
        <Divider style={{ marginTop: '2%' }} />
        <div style={{ marginLeft: '1%' }}>
          <ReviewPreview
            mode={record?.mode}
            criterias={record?.criteriaSet?.criterias}
            onChange={(val) =>
              setSubmitData({
                ...submitData,
                criteriaSet: val,
              })
            }
          />
        </div>
        <Space style={{ marginTop: '2%' }}>
          <AlignLeftOutlined style={{ color: 'rgba(0, 0, 0, 0.45)' }} />
          <Text type="secondary">Overall Comment</Text>
        </Space>
        <Divider orientation="left" style={{ marginTop: 0, marginBottom: 0 }} />
        <div style={{ marginTop: '2%' }}>
          {record?.mode === 'edit' && (
            <TextArea
              placeholder="Add your overall comment"
              allowClear
              autoSize={{ minRows: 3, maxRows: 5 }}
              value={submitData?.overallComment}
              onChange={(e) => setSubmitData({ ...submitData, overallComment: e.target.value })}
            />
          )}
          {record?.mode === 'view' && (
            <Typography
              style={{ fontSize: 17, color: 'grey', padding: 0, width: 500, cursor: 'default' }}>
              {submitData?.overallComment && !!submitData?.overallComment?.replace(regex, '').length
                ? ReactHtmlParser(submitData?.overallComment)
                : ''}
            </Typography>
          )}
        </div>
        <Row style={{ alignItems: 'center', marginTop: 20 }}>
          <Space>
            <Title level={5}>Activity</Title>
            <RetweetOutlined style={{ fontSize: 20 }} />
          </Space>
        </Row>
        <Link onClick={() => setShowContent(!showContent)}>
          <Space className="div_hover">
            <Text>Show Activities</Text>
            {!showContent ? (
              <CaretDownOutlined style={{ marginTop: 7, color: 'rgba(0,0,0,0.7)' }} />
            ) : (
              <CaretUpOutlined style={{ marginTop: 7, color: 'rgba(0,0,0,0.7)' }} />
            )}
          </Space>
        </Link>
        {record?.peerReviewHistory?.length !== 0 &&
          showContent &&
          record?.peerReviewHistory?.map((item: any, key: any) => {
            return (
              <div key={key} className="borderBox">
                <Row>
                  <Space>
                    <UserAvatar src={item?.image} />
                    <Text strong>{item?.name}</Text>
                    {/*<Text type="secondary">{item.
                    date + ' ' + item.time}</Text>*/}
                  </Space>
                </Row>
                <Row>
                  <Text strong>
                    Status:
                    {(record.status == '' || record.status == 'not submitted') && (
                      <Tag color={'blue'}>Not submitted</Tag>
                    )}
                    {item.status == 'submitted' && <Tag color={'yellow'}>Submitted</Tag>}
                    {item.status == 'approved' && <Tag color={'green'}>Approved</Tag>}
                  </Text>
                </Row>
                {item?.status === 'submitted' &&
                  item.history?.map((e: any, index1: any) => {
                    return (
                      <div key={index1}>
                        <Row style={{ marginTop: 20 }}>
                          <Text type="secondary">{`Submitted ${e.criteriaName}`}</Text>
                        </Row>
                        {e.newAnswer !== 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Answer</Text>
                            </Row>
                            <Row style={{ marginLeft: 20 }}>
                              <Rate
                                value={(e.newAnswer / 100) * e.criteriaType ?? 0}
                                character={<StarFilled style={{ fontSize: 15 }} />}
                                count={e.type}
                                disabled={true}
                              />
                            </Row>
                          </div>
                        )}
                        {e.newAnswer !== 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Comment</Text>
                            </Row>
                            <Row style={{ marginLeft: 20 }}>
                              <Text type="secondary">
                                {e.newComment && !!e.newComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.newComment)
                                  : ''}
                              </Text>
                            </Row>
                          </div>
                        )}
                        {e.newAnswer === 0 && e.oldAnswer === 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Comment</Text>
                            </Row>
                            <Row style={{ marginLeft: 20 }}>
                              <Text type="secondary">
                                {e.newComment && !!e.newComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.newComment)
                                  : ''}
                              </Text>
                            </Row>
                          </div>
                        )}
                      </div>
                    );
                  })}
                {item?.status !== 'submitted' &&
                  item.history?.map((e: any, index1: any) => {
                    return (
                      <div key={index1}>
                        <Row style={{ marginTop: 10 }}>
                          <Text type="secondary">{`Updated ${e.criteriaName}`}</Text>
                        </Row>
                        {e.newAnswer !== 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Answer</Text>
                            </Row>
                            <Row style={{ marginLeft: 20, display: 'flex', alignItems: 'center' }}>
                              <Rate
                                value={(e.oldAnswer / 100) * e.criteriaType ?? 0}
                                character={<StarFilled style={{ fontSize: 15 }} />}
                                count={e.type}
                                disabled={true}
                              />
                              <ArrowRightOutlined
                                style={{ paddingTop: 6, paddingLeft: 15, paddingRight: 15 }}
                              />
                              <Rate
                                value={(e.newAnswer / 100) * e.criteriaType ?? 0}
                                character={<StarFilled style={{ fontSize: 15 }} />}
                                count={e.type}
                                disabled={true}
                              />
                            </Row>
                          </div>
                        )}
                        {e.newAnswer !== 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Comment</Text>
                            </Row>

                            <Row style={{ marginLeft: 20, display: 'flex', alignItems: 'center' }}>
                              <Text type="secondary">
                                {e.oldComment && !!e.oldComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.oldComment)
                                  : ''}
                              </Text>
                              <ArrowRightOutlined style={{ paddingLeft: 15, paddingRight: 15 }} />
                              <Text type="secondary">
                                {e.newComment && !!e.newComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.newComment)
                                  : ''}
                              </Text>
                            </Row>
                          </div>
                        )}
                        {e.newAnswer === 0 && e.oldAnswer === 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Comment</Text>
                            </Row>
                            <Row style={{ marginLeft: 20 }}>
                              <Text type="secondary">
                                {e.oldComment && !!e.oldComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.oldComment)
                                  : ''}
                              </Text>
                              <ArrowRightOutlined style={{ paddingLeft: 15, paddingRight: 15 }} />
                              <Text type="secondary">
                                {e.newComment && !!e.newComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.newComment)
                                  : ''}
                              </Text>
                            </Row>
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
            );
          })}
      </Modal>
    </WebUxPage>
  );
};

export default UserPeerReviews;
